<template>
  <div :class="['grid', `grid-cols-${numCols}`, 'gap-7']">
    <div class="flex flex-col"
      v-if="includeSchoolYearSelect">
      <ValidationProvider
        :rules="'required'"
        name="requiredDataSchoolYearCode"
        v-slot="{ errors }">
        <VSelectionField
          :disabled="!enableSchoolYearSelect"
          v-model="model.schoolYearCode"
          :options="schoolYearOptions"
          @input="formValueChanged">
          School Year:
        </VSelectionField>
        <span
          class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          name="error-text">
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </div>
    <div class="flex flex-col"
      v-if="includePartitionSelect">
      <ValidationProvider
        :rules="'required'"
        name="requiredDataPartitionId"
        v-slot="{ errors }">
        <VSelectionField
          :disabled="!enablePartitionSelect"
          v-model="model.partitionId"
          :options="partitionOptions"
          @input="formValueChanged">
          Partition:
        </VSelectionField>
        <span
          class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          name="error-text">
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </div>
    <div class="flex flex-col"
      v-if="includeDistrictSelect">
      <ValidationProvider
        :rules="'required'"
        name="requiredDataDistrictCode"
        v-slot="{ errors }">
        <VSelectionField
          :disabled="!enableDistrictSelect"
          v-model="model.districtCode"
          :options="districtOptions"
          @input="formValueChanged">
          District:
        </VSelectionField>
        <span
          class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          name="error-text">
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </div>
    <div class="flex flex-col"
      v-if="includeVendorSelect">
      <ValidationProvider
        :rules="'required'"
        name="requiredDataVendorId"
        v-slot="{ errors }">
        <VSelectionField
          :disabled="!enableVendorSelect"
          v-model="model.vendorId"
          :options="vendorOptions"
          @input="formValueChanged">
          Vendor:
        </VSelectionField>
        <span
          class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          name="error-text">
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </div>
    <div class="flex flex-col"
      v-if="includeBuildingSelect">
      <ValidationProvider
        :rules="'required'"
        name="requiredDataBuildingCode"
        v-slot="{ errors }">
        <VSelectionField
          :disabled="!enableBuildingSelect"
          v-model="model.buildingId"
          :options="buildingOptions"
          @input="formValueChanged">
          Building:
        </VSelectionField>
        <span
          class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
          name="error-text">
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import VSelectionField from '../components/formComponents/VSelectionField.vue'

import { localize } from 'vee-validate'

localize({
  en: {
    fields: {
      requiredDataSchoolYearCode: {
        required: 'School Year is required',
      },
      requiredDataPartitionId: {
        required: 'Partition is required',
      },
      requiredDataDistrictCode: {
        required: 'District is required',
      },
      requiredDataVendorId: {
        required: 'Vendor is required',
      },
      requiredDataBuildingCode: {
        required: 'Building is required',
      },
    }
  }
})

export default {
  components: {
    VSelectionField,
  },
  props: {
    includeSchoolYearSelect: {
      type: Boolean,
      default: false,
    },
    includePartitionSelect: {
      type: Boolean,
      default: false,
    },
    includeDistrictSelect: {
      type: Boolean,
      default: false,
    },
    includeVendorSelect: {
      type: Boolean,
      default: false,
    },
    includeBuildingSelect: {
      type: Boolean,
      default: false,
    },
    enableSchoolYearSelect: {
      type: Boolean,
      default: false,
    },
    enablePartitionSelect: {
      type: Boolean,
      default: false,
    },
    enableDistrictSelect: {
      type: Boolean,
      default: false,
    },
    enableVendorSelect: {
      type: Boolean,
      default: false,
    },
    enableBuildingSelect: {
      type: Boolean,
      default: false,
    },
    schoolYearOptions: {
      type: [Object, Array],
      default: () => [],
    },
    partitionOptions: {
      type: Array,
      default: () => [],
    },
    districtOptions: {
      type: Array,
      default: () => [],
    },
    vendorOptions: {
      type: Array,
      default: () => [],
    },
    buildingOptions: {
      type: Array,
      default: () => [],
    },

    numCols: {
      type: Number,
      default: 3,
    },
    // modelValue: Object,
    value: Object,
  },
  data() {
    return {
      formValues: {
        schoolYearCode: undefined,
        partitionId: undefined,
        districtCode: undefined,
        vendorId: undefined,
        buildingId: undefined,
      },
    }
  },
  methods: {
    formValueChanged() {
      // this.$emit('input', this.formValues)
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  async mounted() {
    // this.formValues = this.modelValue
  },
  // watch: {
  //   modelValue(newValue) {
  //     console.log(newValue)
  //     this.formValues = newValue
  //   }
  // }
}
</script>